// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"7e76ef03","358":"093e8ab1"}[chunkId] + ".chunk.js";
};